{
  "beer": [
    "M17 11h1a3 3 0 0 1 0 6h-1",
    "M9 12v6",
    "M13 12v6",
    "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
    "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
  ],
  "wine": [
    "M8 22h8",
    "M7 10h10",
    "M12 15v7",
    "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"
  ],
  "martini": [
    "M12 12 4.207 4.207A.707.707 0 0 1 4.707 3h14.586a.707.707 0 0 1 .5 1.207z",
    "M12 12v10",
    "M7 22h10"
  ],
  "glass-water": [
    "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
    "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0"
  ],
  "cup-soda": [
    "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8",
    "M5 8h14",
    "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0",
    "m12 8 1-6h2"
  ],
  "milk": [
    "M8 2h8",
    "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
    "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0"
  ],
  "hop": [
    "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
    "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
    "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
    "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
    "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
    "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
    "M4.93 4.93 3 3a.7.7 0 0 1 0-1",
    "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15"
  ],
  "wheat": [
    "M2 22 16 8",
    "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
    "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
    "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
    "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z",
    "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
    "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
    "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z"
  ],
  "apple": [
    "M12 6.528V3a1 1 0 0 1 1-1h0",
    "M18.237 21A15 15 0 0 0 22 11a6 6 0 0 0-10-4.472A6 6 0 0 0 2 11a15.1 15.1 0 0 0 3.763 10 3 3 0 0 0 3.648.648 5.5 5.5 0 0 1 5.178 0A3 3 0 0 0 18.237 21"
  ],
  "grape": [
    "M22 5V2l-5.89 5.89",
    "M 13.600000000000001 15.89 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 5.109999999999999 7.4 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 9.35 11.65 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 10.91 5.85 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 15.149999999999999 10.09 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 3.5599999999999996 13.2 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 7.800000000000001 17.44 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0",
    "M 2 19 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0"
  ],
  "citrus": [
    "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
    "M19.65 15.66A8 8 0 0 1 8.35 4.34",
    "m14 10-5.5 5.5",
    "M14 17.85V10H6.15"
  ],
  "calendar-days": [
    "M8 2v3",
    "M16 2v3",
    "M 5 3 H 19 a 2 2 0 0 1 2 2 V 19 a 2 2 0 0 1 -2 2 H 5 a 2 2 0 0 1 -2 -2 V 5 a 2 2 0 0 1 2 -2 Z",
    "M3 9h18",
    "M8 13h.01",
    "M12 13h.01",
    "M16 13h.01",
    "M8 17h.01",
    "M12 17h.01",
    "M16 17h.01"
  ],
  "clock": [
    "M 2 12 a 10 10 0 1 0 20 0 a 10 10 0 1 0 -20 0",
    "M12 6v6l4 2"
  ],
  "map-pin": [
    "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
    "M 9 10 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0"
  ],
  "map": [
    "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
    "M15 5.764v15",
    "M9 3.236v15"
  ],
  "trophy": [
    "M10 14.66V17a1 1 0 0 1-1 1 2 2 0 0 0-2 2v2",
    "M14 14.66V17a1 1 0 0 0 1 1 2 2 0 0 1 2 2v2",
    "M17.916 10H19.5A2.5 2.5 0 0 0 22 7.5V5a1 1 0 0 0-1-1h-3",
    "M4 22h16",
    "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z",
    "M6.084 10H4.5A2.5 2.5 0 0 1 2 7.5V5a1 1 0 0 1 1-1h3"
  ],
  "medal": [
    "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
    "M11 12 5.12 2.2",
    "m13 12 5.88-9.8",
    "M8 7h8",
    "M 7 17 a 5 5 0 1 0 10 0 a 5 5 0 1 0 -10 0",
    "M12 18v-2h-.5"
  ],
  "award": [
    "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
    "M 6 8 a 6 6 0 1 0 12 0 a 6 6 0 1 0 -12 0"
  ],
  "star": [
    "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
  ],
  "heart": [
    "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
  ],
  "mic": [
    "M12 19v3",
    "M19 10v2a7 7 0 0 1-14 0v-2",
    "M 12 2 H 12 a 3 3 0 0 1 3 3 V 12 a 3 3 0 0 1 -3 3 H 12 a 3 3 0 0 1 -3 -3 V 5 a 3 3 0 0 1 3 -3 Z"
  ],
  "guitar": [
    "m11.9 12.1 4.514-4.514",
    "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
    "m6 16 2 2",
    "M8.23 9.85A3 3 0 0 1 11 8a5 5 0 0 1 5 5 3 3 0 0 1-1.85 2.77l-.92.38A2 2 0 0 0 12 18a4 4 0 0 1-4 4 6 6 0 0 1-6-6 4 4 0 0 1 4-4 2 2 0 0 0 1.85-1.23z"
  ],
  "ticket": [
    "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
    "M13 5v2",
    "M13 17v2",
    "M13 11v2"
  ],
  "tent": [
    "M3.5 21 14 3",
    "M20.5 21 10 3",
    "M15.5 21 12 15l-3.5 6",
    "M2 21h20"
  ],
  "party-popper": [
    "M5.8 11.3 2 22l10.7-3.79",
    "M4 3h.01",
    "M22 8h.01",
    "M15 2h.01",
    "M22 20h.01",
    "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
    "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17",
    "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7",
    "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"
  ],
  "sparkles": [
    "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
    "M20 2v4",
    "M22 4h-4",
    "M 2 20 a 2 2 0 1 0 4 0 a 2 2 0 1 0 -4 0"
  ],
  "bus": [
    "M8 6v6",
    "M15 6v6",
    "M2 12h19.6",
    "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
    "M5 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0",
    "M9 18h5",
    "M14 18a2 2 0 1 0 4 0a2 2 0 1 0-4 0"
  ],
  "train-front": [
    "M8 3.1V7a4 4 0 0 0 8 0V3.1",
    "m9 15-1-1",
    "m15 15 1-1",
    "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z",
    "m8 19-2 3",
    "m16 19 2 3"
  ],
  "bike": [
    "M 15.0 17.5 a 3.5 3.5 0 1 0 7.0 0 a 3.5 3.5 0 1 0 -7.0 0",
    "M 2.0 17.5 a 3.5 3.5 0 1 0 7.0 0 a 3.5 3.5 0 1 0 -7.0 0",
    "M 14 5 a 1 1 0 1 0 2 0 a 1 1 0 1 0 -2 0",
    "M12 17.5V14l-3-3 4-3 2 3h2"
  ],
  "footprints": [
    "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
    "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
    "M16 17h4",
    "M4 13h4"
  ],
  "users": [
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    "M16 3.128a4 4 0 0 1 0 7.744",
    "M22 21v-2a4 4 0 0 0-3-3.87",
    "M 5 7 a 4 4 0 1 0 8 0 a 4 4 0 1 0 -8 0"
  ],
  "user-plus": [
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    "M 5 7 a 4 4 0 1 0 8 0 a 4 4 0 1 0 -8 0",
    "M19 8v6",
    "M22 11h-6"
  ],
  "hand-heart": [
    "M11 14h2a2 2 0 0 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16",
    "m14.45 13.39 5.05-4.694C20.196 8 21 6.85 21 5.75a2.75 2.75 0 0 0-4.797-1.837.276.276 0 0 1-.406 0A2.75 2.75 0 0 0 11 5.75c0 1.2.802 2.248 1.5 2.946L16 11.95",
    "m2 15 6 6",
    "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a1 1 0 0 0-2.75-2.91"
  ],
  "handshake": [
    "m11 17 2 2a1 1 0 1 0 3-3",
    "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
    "m21 3 1 11h-2",
    "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3",
    "M3 4h8"
  ],
  "megaphone": [
    "M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z",
    "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14",
    "M8 6v8"
  ],
  "vote": [
    "m9 12 2 2 4-4",
    "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z",
    "M22 19H2"
  ],
  "landmark": [
    "M10 18v-7",
    "M11.119 2.205a2 2 0 0 1 1.762 0l7.84 3.846A.5.5 0 0 1 20.5 7h-17a.5.5 0 0 1-.22-.949z",
    "M14 18v-7",
    "M18 18v-7",
    "M3 22h18",
    "M6 18v-7"
  ],
  "store": [
    "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5",
    "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
    "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05"
  ],
  "house": [
    "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
    "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  ],
  "factory": [
    "M12 16h.01",
    "M16 16h.01",
    "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z",
    "M8 16h.01"
  ],
  "flag": [
    "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
  ],
  "book-open": [
    "M12 5v16",
    "M20.001 19A2 2 0 0 0 22 17V5a2 2 0 0 0-1.999-2L16 3.002A5 5 0 0 0 12 5a5 5 0 0 0-4-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 1.999 2H8a5 5 0 0 1 4 2 5 5 0 0 1 4-2z"
  ],
  "newspaper": [
    "M15 18h-5",
    "M18 14h-8",
    "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2",
    "M 11 6 H 17 a 1 1 0 0 1 1 1 V 9 a 1 1 0 0 1 -1 1 H 11 a 1 1 0 0 1 -1 -1 V 7 a 1 1 0 0 1 1 -1 Z"
  ],
  "key": [
    "m2 21 9.6-9.6",
    "m7.5 15.5 2.3 2.3a1 1 0 0 1 0 1.4l-2.1 2.1a1 1 0 0 1-1.4 0L4 19",
    "M10 7.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0"
  ],
  "puzzle": [
    "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z"
  ],
  "dices": [
    "M 4 10 H 12 a 2 2 0 0 1 2 2 V 20 a 2 2 0 0 1 -2 2 H 4 a 2 2 0 0 1 -2 -2 V 12 a 2 2 0 0 1 2 -2 Z",
    "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6",
    "M6 18h.01",
    "M10 14h.01",
    "M15 6h.01",
    "M18 9h.01"
  ],
  "target": [
    "M 2 12 a 10 10 0 1 0 20 0 a 10 10 0 1 0 -20 0",
    "M 6 12 a 6 6 0 1 0 12 0 a 6 6 0 1 0 -12 0",
    "M 10 12 a 2 2 0 1 0 4 0 a 2 2 0 1 0 -4 0"
  ],
  "utensils": [
    "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2",
    "M7 2v20",
    "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
  ],
  "sun": [
    "M 8 12 a 4 4 0 1 0 8 0 a 4 4 0 1 0 -8 0",
    "M12 2v2",
    "M12 20v2",
    "m4.93 4.93 1.41 1.41",
    "m17.66 17.66 1.41 1.41",
    "M2 12h2",
    "M20 12h2",
    "m6.34 17.66-1.41 1.41",
    "m19.07 4.93-1.41 1.41"
  ],
  "snowflake": [
    "m10 20-1.25-2.5L6 18",
    "M10 4 8.75 6.5 6 6",
    "m14 20 1.25-2.5L18 18",
    "m14 4 1.25 2.5L18 6",
    "m17 21-3-6h-4",
    "m17 3-3 6 1.5 3",
    "M2 12h6.5L10 9",
    "m20 10-1.5 2 1.5 2",
    "M22 12h-6.5L14 15",
    "m4 10 1.5 2L4 14",
    "m7 21 3-6-1.5-3",
    "m7 3 3 6h4"
  ],
  "leaf": [
    "M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20",
    "M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13"
  ],
  "trees": [
    "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
    "M7 16v6",
    "M13 19v3",
    "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5"
  ],
  "gift": [
    "M12 7v14",
    "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8",
    "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5",
    "M 4 7 H 20 a 1 1 0 0 1 1 1 V 10 a 1 1 0 0 1 -1 1 H 4 a 1 1 0 0 1 -1 -1 V 8 a 1 1 0 0 1 1 -1 Z"
  ],
  "camera": [
    "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
    "M 9 13 a 3 3 0 1 0 6 0 a 3 3 0 1 0 -6 0"
  ],
  "lightbulb": [
    "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
    "M9 18h6",
    "M10 22h4"
  ],
  "beer-off": [
    "M13 13v5",
    "M17 11.47V8",
    "M17 11h1a3 3 0 0 1 2.745 4.211",
    "m2 2 20 20",
    "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3",
    "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268",
    "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
    "M9 14.6V18"
  ],
  "piggy-bank": [
    "M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z",
    "M16 10h.01",
    "M2 8v1a2 2 0 0 0 2 2h1"
  ],
  "badge-percent": [
    "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
    "m15 9-6 6",
    "M9 9h.01",
    "M15 15h.01"
  ],
  "signpost": [
    "M12 13v8",
    "M12 3v3",
    "M2.354 10.354a1.207 1.207 0 0 1 0-1.708l2.06-2.06A2 2 0 0 1 5.828 6h12.344a2 2 0 0 1 1.414.586l2.06 2.06a1.207 1.207 0 0 1 0 1.708l-2.06 2.06a2 2 0 0 1-1.414.586H5.828a2 2 0 0 1-1.414-.586z"
  ],
  "church": [
    "M10 9h4",
    "M12 7v5",
    "M14 21v-3a2 2 0 0 0-4 0v3",
    "m18 9 3.52 2.147a1 1 0 0 1 .48.854V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.999a1 1 0 0 1 .48-.854L6 9",
    "M6 21V7a1 1 0 0 1 .376-.782l5-3.999a1 1 0 0 1 1.249.001l5 4A1 1 0 0 1 18 7v14"
  ],
  "castle": [
    "M10 5V3",
    "M14 5V3",
    "M15 21v-3a3 3 0 0 0-6 0v3",
    "M18 3v8",
    "M18 5H6",
    "M22 11H2",
    "M22 9v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9",
    "M6 3v8"
  ],
  "crown": [
    "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
    "M5 21h14"
  ]
}
